import { EventEmitter } from 'events';

class EventBus extends EventEmitter {
  // The "any" typing here allows you to emit any type of payload for any string event
  emit(event: string, payload?: any): boolean {
    return super.emit(event, payload);
  }

  // Similar flexibility for the on listener
  on(event: string, listener: (...args: any[]) => void): this {
    return super.on(event, listener);
  }
}

export default new EventBus();